import {
  Sheet,
  SheetContent,
  SheetDescription,
  SheetHeader,
  SheetTitle,
} from '@/components/ui/sheet';
import { PlannerConfigEntityWithOptionalFields } from '@/services/configurator/PlannerConfigTypes';
import { JSX } from 'react';
import { useNavigate } from 'react-router-dom';
import { EditForm } from '../form/EditForm';

export type Mode = 'edit' | 'create';

export type PlannerPageContainerProps = {
  title: string;
  description: string;
  planner: PlannerConfigEntityWithOptionalFields;
  onSubmit: (data: PlannerConfigEntityWithOptionalFields) => void;
  renderAdditionalHeaderContent?: () => JSX.Element;
  mode: Mode;
  disabledPhraseFields: boolean;
  disabledFormFields: boolean;
  isSubmitting?: boolean;
};

export function PlannerPageContainer({
  title,
  description,
  planner,
  onSubmit,
  renderAdditionalHeaderContent,
  mode,
  disabledPhraseFields,
  disabledFormFields,
  isSubmitting,
}: PlannerPageContainerProps) {
  const navigate = useNavigate();

  return (
    <Sheet
      open={true}
      onOpenChange={() => {
        navigate('/');
      }}
    >
      <SheetContent side={'bottom'}>
        <SheetHeader className='flex flex-row justify-between'>
          <div>
            <SheetTitle>{title}</SheetTitle>
            <SheetDescription>{description}</SheetDescription>
          </div>
        </SheetHeader>
        <EditForm
          planner={planner}
          onSubmit={onSubmit}
          mode={mode}
          disabledPhraseFields={disabledPhraseFields}
          disabledFormFields={disabledFormFields}
          renderAdditionalHeaderContent={renderAdditionalHeaderContent}
          isSubmitting={isSubmitting}
        />
      </SheetContent>
    </Sheet>
  );
}
